// extracted by mini-css-extract-plugin
module.exports = {"root":"az_VW","input":"az_WW","toggle-background":"az_XW","toggle-knob":"az_YW"};